// This is a Mixin that extends the base functionality
// of MpNotes Controller, for channel notes page
var MpChannelNotes = {
    created: function () {},
    data: function() {
        return {
            CHANNEL_PAGE_URL: '/notes/channel/source/[*SOURCE*]/format/json/page/',
        };
    },
    computed: {

        requestURL: function() {
            // CHANNEL_SOURCE is injected through php controller
            console.log(CHANNEL_SOURCE);
            return this.CHANNEL_PAGE_URL.replace('[*SOURCE*]', CHANNEL_SOURCE) + this.page;
        },

    },
    methods: {

        loadItems: function() {
            axios
                .post(this.requestURL)
                .then(this.onItemsLoaded)
                .catch(function(error) {
                    console.log(error);
                });
        },
    },

    mounted: function() {
        this.$refs.ssrItemList.querySelectorAll('.js-item').forEach(this.addDomItem);
    }
};
